module.exports = __webpack_public_path__ + "img/loginBack.c69256c1.png";